import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { RxStateComponent } from '@alliance/shared/models'
import { MediaService } from '@alliance/shared/utils'
import { ClubPost } from '@alliance/clubs/domain'

import { Translations } from '../../localization/translations'
import { RoutingService } from '@alliance/clubs/utils'

@Component({
  selector: 'alliance-clubs-related-posts',
  templateUrl: './related-posts.component.html',
  styleUrls: ['./related-posts.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedPostsComponent extends RxStateComponent<{
  relatedPosts: ClubPost[] | null
  isMobileScreen: boolean
}> {
  public state = this.connectViewState(['relatedPosts', 'isMobileScreen'])

  public constructor(private mediaService: MediaService, public translations: Translations, private routingService: RoutingService) {
    super()

    this.initState({
      relatedPosts: null,
      isMobileScreen: this.mediaService.select('isMobileScreen')
    })
  }

  @Input()
  public set relatedPosts(value: ClubPost[] | null) {
    this.set({
      relatedPosts: value
    })
  }

  public getPostPageRouterLink(post: ClubPost | null): string {
    if (!post || !post?.topics[0]?.engname || !post?.slug) {
      return ''
    }

    const params = {
      topicName: post?.topics[0].engname,
      postSlug: post?.slug
    }
    return this.routingService.getPostPageRouterLink(params)
  }

  public trackByFn(index: number): number {
    return index
  }
}
